import { ActionIcon } from '@mantine/core';
import { ChevronRightIcon } from 'lucide-react';
import styles from './CollapseButton.module.css';

const CollapseButton = ({
  isCollapsed,
  onToggleCollapse,
  collapsedIcon,
  expandedIcon,
  className,
}: {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  collapsedIcon?: React.ReactNode;
  expandedIcon?: React.ReactNode;
  className?: string;
}) => {
  return (
    <ActionIcon
      aria-label={'Collapse'}
      className={`${styles.collapseButton} ${className ?? ''}`}
      variant='transparent'
      onClick={onToggleCollapse}
      color='text'
      // KLUDGE: Hostile to accessibility, but I can't figure out how to
      // keep this component from capturing focus otherwise.
      tabIndex={-1}
    >
      <div
        className={`${styles.transformWrapper} ${
          isCollapsed ? styles.collapsed : ''
        }`}
      >
        {isCollapsed &&
          (collapsedIcon ?? <ChevronRightIcon size={16} strokeWidth={2} />)}
        {!isCollapsed &&
          (expandedIcon ?? <ChevronRightIcon size={16} strokeWidth={2} />)}
      </div>
    </ActionIcon>
  );
};

export default CollapseButton;
